export default {
    telePhone:"400-630-0009",
}
